import {
  CompareToggleButton,
  cardCompareOrigin,
  useCompareToggle,
} from "@/components/organisms/Players/MrDbListCardView/PlayersCardView";
import { PlayerCardWithMetaRating } from "@/design-system/PlayerCard/PlayerCard";
import { MetaRatingsPlayer } from "@/redux/players/playersSlice";
import { evolutionFooterFrom } from "@repo/shared/evolutions";
import { Player } from "@repo/shared/types";

export const GRID_CARD_SCALE = 0.9;

/** The front page's card tile, for the players list's grid view. */
export const PlayerGridCard = ({
  player,
  playerRoleId,
  show3Chem,
}: {
  player: MetaRatingsPlayer;
  playerRoleId?: number;
  show3Chem: boolean;
}) => {
  const graded = {
    ...player,
    playerRoleId: playerRoleId ?? player.playerRoleId,
  };
  const { compareMode, isInCompare, handleToggleCompare } = useCompareToggle(
    { ...graded, chemistry: show3Chem ? 3 : 0 } as never,
    cardCompareOrigin(player),
  );

  return (
    <div className="group relative w-full">
      <PlayerCardWithMetaRating
        hideLabel
        fullWidth
        scale={GRID_CARD_SCALE}
        player={graded as unknown as Player}
        // Tiers are graded at 0 chem, even when the list sorts at 3.
        tierMetaRating={show3Chem ? player.metaRatingZeroChem : undefined}
        evolution={evolutionFooterFrom(player.evolutionData)}
      />
      {compareMode && (
        <CompareToggleButton
          isInCompare={isInCompare}
          onToggle={handleToggleCompare}
        />
      )}
    </div>
  );
};
